import { CDeliveryChain, defaultDeliveryChainParameters, deleteKeys, Paths } from "@ts/ui-models";
import { normalizeForwarderParams, normalizeTransporterParams } from "./deliveryChains.normalizer.utils";
import { TTextType } from "@ts/storybook";

export const normalizeCDeliveryChain = (
    entity: { oldEntity: CDeliveryChain; newEntity: CDeliveryChain },
    attr: Paths<CDeliveryChain>,
    notify?: (message: TTextType) => void,
    errory?: (value: boolean) => void
) => {
    const { oldEntity, newEntity } = entity;
    const params = newEntity.parameters ?? defaultDeliveryChainParameters;

    if (attr === 'parameters.geometryFilterEnabled') {
        if (newEntity.parameters.geometryFilterEnabled) return newEntity;

        const nextParams = deleteKeys(params, ['locationId', 'geometry']);

        return {
            ...newEntity,
            parameters: nextParams,
        };
    }
    if (attr === 'forwarderId') {
        if (!newEntity.forwarderId) return newEntity;
        notify?.(['Forwarder', ' ', 'selected', ', ', 'updating parameters for sending', '.']);

        const nextParams = normalizeForwarderParams(newEntity.forwarderId, params);

        return {
            ...newEntity,
            parameters: nextParams,
        };
    }

    if (attr === 'transporterId') {
        if (!newEntity.transporterId) return newEntity;
        notify?.(['Transporter', ' ', 'selected', ', ', 'updating parameters for sending', '.']);

        const nextParams = normalizeTransporterParams(newEntity.transporterId, params);

        return {
            ...newEntity,
            parameters: nextParams,
        };
    }

    if (attr === 'parameters.sensorPlacementSettings') {
        const nextParams = normalizeTransporterParams('discoveryRTLSApp', params);

        return {
            ...newEntity,
            parameters: nextParams,
        };
    }

    return newEntity;
};
